
<div class="container kh-title-text w-100">
    <div class="row settings-row kh-medium-text">
        <div class="col-9">
            <div class="row">
                <div class="col-md-4 col-sm-12">
                    <div class="settings-label kh-lg-title-text kh-text-primary">
                        {{label}}
                    </div>
                </div>
                <div class="col-md-8 col-sm-12 d-flex align-items-center preserve-line-breaks">
                    {{value}}
                </div>
            </div>
        </div>
        <div class="col-3 d-flex align-items-center justify-content-end">
            <kh-dropdown-menu [alignmentRight]="true" [ariaLabel]="menuLabel" class="ml-xs">
                <div class="pointer" header>
                    <span class="menuLabel">{{menuLabel}}
                        <svg class="icon right-arrow-icon" id="Layer_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 88.35">
                            <g id="Layer_2-2">
                                <g id="Layer_1-2">
                                    <path d="M0,76.74c0-1.78,.42-3.54,1.22-5.13,.8-1.59,1.95-2.98,3.38-4.05l26.35-19.99c.58-.39,1.06-.91,1.39-1.53,.33-.62,.5-1.3,.5-2s-.17-1.39-.5-2c-.33-.62-.81-1.14-1.39-1.53L4.59,20.88c-1.43-1.09-2.58-2.49-3.38-4.09C.42,15.18,0,13.41,0,11.62c-.02-2.16,.57-4.28,1.69-6.11,1.13-1.84,2.74-3.33,4.67-4.29S10.45-.15,12.6,.05c2.15,.2,4.19,1.01,5.91,2.32L51.7,27.36c2.58,1.98,4.67,4.52,6.11,7.44,1.44,2.92,2.19,6.12,2.19,9.37s-.75,6.46-2.19,9.37-3.53,5.46-6.11,7.44l-33.19,25.01c-1.71,1.31-3.76,2.11-5.91,2.32-2.15,.2-4.31-.2-6.24-1.16s-3.55-2.45-4.67-4.29C.57,81.02-.02,78.9,0,76.74Z"></path>
                                </g>
                            </g>
                        </svg>
                    </span>
                </div>
                <ng-content select="[menu-items]"></ng-content>
            </kh-dropdown-menu>
        </div>
    </div>
</div>
